import { useEffect, useState } from "react";
import Input from "../../components/form/input/InputField";
import Label from "../../components/form/Label";
import { Link } from "react-router";
import { ChevronLeftIcon, EyeCloseIcon, EyeIcon } from "../../icons";
import Checkbox from "../../components/form/input/Checkbox";
import Button from "../../components/ui/button/Button";
import PageMeta from "../../components/common/PageMeta";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

interface MyTokenPayload {
  id: number;
  groupid: number;
  username: string;
  iat?: number;
  exp?: number;
}

export default function SignIn() {
  const [showPassword, setShowPassword] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  // console.log("this is token from localStorage", token);

  ///Redirect if already logged in
  useEffect(() => {
    // Check if the token exists in localStorage
    if (token) {
      // navigate("/customer-surveys"); // Redirect to the desired page
    }
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
  e.preventDefault();

  if (!token) {
    // console.log("Token not found in localStorage");
    return;
  }

  try {
    const response = await fetch(`http://localhost:4000/api/auth/login?cookie=${encodeURIComponent(token)}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ username, password })
    });

    const data = await response.json();
    // console.log("this is tooken", data);
    
    const dtoken = data.token;
    // console.log("this is dtoken",token);
    
    // Decode payload without verifying signature
    const decoded = jwtDecode<MyTokenPayload>(dtoken); 
    // console.log("this is decoded",decoded);

    // After login success
    localStorage.setItem("username", decoded.username);
    localStorage.setItem("user_id", decoded.id.toString());
    localStorage.setItem("groupid", decoded.groupid.toString());


    // if (response.ok && data.redirect) {
    //   //Redirect manually
    //   window.location.href = data.redirect;
    // } else {
    //   //Handle error
    //   alert(data.message || "Login failed");
    // }
  } catch (error) {
    console.error("Login error:", error);
    alert(error);
    console.log(error);
  }
};


  return (
    <>
      <PageMeta
        title="Sign In"
        description="This is the sign in page of the application"
      />
      <div className="relative flex w-full h-screen px-4 py-6 overflow-hidden bg-white z-1 dark:bg-gray-900 sm:p-0">
        <div className="flex flex-col flex-1 p-6 rounded-2xl sm:rounded-none sm:border-0 sm:p-8">
          <div className="w-full max-w-md pt-10 mx-auto">
            <Link
              to="/"
              className="inline-flex items-center text-sm text-gray-500 transition-colors hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
            >
              <ChevronLeftIcon />
              Back to dashboard
            </Link>
          </div>
          <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
            <div>
              <div className="mb-5 sm:mb-8">
                <h1 className="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
                  Sign In
                </h1>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  Enter your Username and password to sign in!
                </p>
              </div>
              <div>
                <form onSubmit={handleSubmit}>
                  <div className="space-y-6">
                    <div>
                      <Label>
                        UserName <span className="text-error-500">*</span>{" "}
                      </Label>
                      <Input placeholder="Enter your username"value={username} onChange={(e) => setUsername(e.target.value)}/>
                    </div>
                    <div>
                      <Label>
                        Password <span className="text-error-500">*</span>{" "}
                      </Label>
                      <div className="relative">
                        <Input type={showPassword ? "text" : "password"} placeholder="Enter your password"value={password}onChange={(e) => setPassword(e.target.value)}/>
                        <span
                          onClick={() => setShowPassword(!showPassword)}
                          className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
                        >
                          {showPassword ? (
                            <EyeIcon className="fill-gray-500 dark:fill-gray-400" />
                          ) : (
                            <EyeCloseIcon className="fill-gray-500 dark:fill-gray-400" />
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <Checkbox checked={isChecked} onChange={setIsChecked} />
                        <span className="block font-normal text-gray-700 text-theme-sm dark:text-gray-400">
                          Keep me logged in
                        </span>
                      </div>
                      <Link
                        to="/"
                        className="text-sm text-brand-500 hover:text-brand-600 dark:text-brand-400"
                      >
                        Forgot password?
                      </Link>
                    </div>
                    <div>
                      <Button className="w-full" size="sm">
                        Sign in
                      </Button>
                    </div>
                  </div>
                </form>

                <div className="mt-5">
                  <p className="text-sm font-normal text-center text-gray-700 dark:text-gray-400 sm:text-start">
                    Don't have an account? {""}
                    <Link
                      to="/signup"
                      className="text-brand-500 hover:text-brand-600 dark:text-brand-400"
                    >
                      Sign Up
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
